import React from 'react';
import AriaModal from 'react-aria-modal';
import PropTypes from 'prop-types';
import { overlayControllerProps } from '../layout/Overlay';
import { FormikForm } from './FormikForm';
import { allowedButtonColors, Button } from './ActionElement';
import { sharedOverlayProps } from '../layout/Overlay/_allowedPropTypes';

class CustomDialog extends React.Component {
  constructor() {
    super();
    this.state = {
      isFormValid: false,
      isProcessing: false
    };

    this.resetFormikForm = null;
  }

  render() {
    const {
      props: {
        isOpen,
        overlayTitle,
        dialogSize = 'normal',
        focusFirstChild,
        noMinHeight = true,
        closerButtonData: {
          buttonContent: closerContent,
          buttonIconName: closerIcon,
          buttonProps: closerProps = {}
        },
        submitButtonData: {
          buttonContent: submitContent,
          buttonIconName: submitIcon,
          buttonColor: submitColor = 'primary',
          buttonProps: submitProps
        },
        classNames = [],
        initialInputValues,
        validationSchema,
        dialogHeading,
        closeDialog,
        onSubmit,
        children
      },
      state: {
        isFormValid,
        isProcessing
      },
      resetFormikForm
    } = this;

    classNames.push('custom-dialog', `dialog-size-${dialogSize}`);

    if (noMinHeight) {
      classNames.push('no-min-height');
    }

    return (
      <AriaModal
        titleText={overlayTitle}
        mounted={isOpen}
        onExit={closeDialog}
        verticallyCenter
        focusDialog={!focusFirstChild}
        getApplicationNode={() => document.getElementById('app')}
        dialogClass={classNames.join(' ')}
        scrollDisabled
      >
        <article className='dialog-content'>
          {dialogHeading ? <h1>{dialogHeading}</h1> : null}

          <FormikForm
            onSubmit={values => {
              this.setState({ isProcessing: true }, async () => {
                await onSubmit({
                  values,
                  closeDialog,
                  resetFormikForm
                });

                this.setState({ isProcessing: false }, () => {
                });
              });
            }}
            getFormikProps={({ dirty, isValid, resetForm }) => {
              const allowSubmit = !initialInputValues && !dirty ? true : isValid;

              if (allowSubmit !== isFormValid) {
                this.setState({ isFormValid: allowSubmit });
              }

              if (!resetFormikForm) {
                this.resetFormikForm = resetForm;
              }
            }}
            initialValues={initialInputValues}
            validationSchema={validationSchema}
          >
            <div className='aria-modal-main'>
              {children}
            </div>

            <div className='dialog-button-area'>
              <Button
                onClick={closeDialog}
                buttonColor='secondary'
                iconName={closerIcon}
                disabled={false}
                {...closerProps}
              >
                {closerContent}
              </Button>

              <Button
                type='submit'
                iconName={submitIcon}
                buttonColor={submitColor}
                disabled={!isFormValid || isProcessing}
                {...submitProps}
              >
                {submitContent}
              </Button>
            </div>
          </FormikForm>
        </article>
      </AriaModal>
    );
  }
}

CustomDialog.propTypes = {
  ...sharedOverlayProps,
  isOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dialogHeading: PropTypes.string,
  triggerButtonData: PropTypes.shape(overlayControllerProps),
  closerButtonData: PropTypes.shape(overlayControllerProps).isRequired,
  submitButtonData: PropTypes.shape({
    ...overlayControllerProps,
    buttonColor: PropTypes.oneOf(allowedButtonColors)
  }).isRequired,
  initialInputValues: PropTypes.object,
  validationSchema: PropTypes.object,
  noMinHeight: PropTypes.bool
};

export default CustomDialog;